import { edmCampaign } from '@bingads-webui/edm-campaign';
import { isEmpty } from 'underscore';

export const loadAudiencesFactory = (cid, aid) => ({ searchFilter, top }) => {
  const payload = {
    top,
    count: true,
    audienceType: 'Remessaging,Product,Custom,CustomerList',
    deliverychannel: 'BingAds,AIM',
    filter: !isEmpty(searchFilter) ? { where: `contains(tolower(Name), '${searchFilter.toLocaleLowerCase().replace(/'/g, "''")}')` } : {},
  };

  return edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Audiences
    .get(payload)
    .toPromise()
    .then(({ value }) => value.map(audience => ({
      key: audience.Id,
      text: audience.Name,
      type: audience.Type,
    })));
};

export const loadAssociatedAudiencesFactory = (cid, aid) => async () => {
  const ncaGoalResponse = await edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .NewCustomerAcquisitionGoals
    .get()
    .toPromise();

  if (ncaGoalResponse && ncaGoalResponse.value && ncaGoalResponse.value.length > 0 && ncaGoalResponse.value[0].Audiences) {
    const audiencesFromGoal = ncaGoalResponse.value[0].Audiences; // These are expected to be { Id, Name }
    const audienceIds = audiencesFromGoal.map(audience => audience.Id);

    if (audienceIds.length === 0) return [];

    const idFilter = audienceIds.map(id => `Id eq ${id}`).join(' or ');
    const audienceDetailsPayload = {
      audienceType: 'Remessaging,Product,Custom,CustomerList',
      deliverychannel: 'BingAds,AIM',
      filter: { where: idFilter },
    };

    const audienceDetailsResponse = await edmCampaign
      .Customers.$withKey(cid)
      .Accounts.$withKey(aid)
      .Audiences
      .get(audienceDetailsPayload)
      .toPromise();

    const detailedAudiences = audienceDetailsResponse.value || [];

    // Fallback to name from ncaGoalResponse if an audience detail is unexpectedly missing.
    return audiencesFromGoal.map((goalAudience) => {
      const detailedInfo = detailedAudiences.find(dAud => dAud.Id === goalAudience.Id);
      return {
        key: goalAudience.Id,
        text: detailedInfo ? detailedInfo.Name : goalAudience.Name,
        type: detailedInfo ? detailedInfo.Type : '',
      };
    });
  }
  return [];
};

export const createOrUpdateNewCustomerAcquisitionGoal = ({ cid, aid }) => (payload) => {
  const edmEntityAccount = edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid);

  const createOrUpdateCall = payload && payload.NewCustomerAcquisitionGoals && payload.NewCustomerAcquisitionGoals.Id === -1
    ? edmEntityAccount.bulkCreate.bind(edmEntityAccount)
    : edmEntityAccount.bulkUpdate.bind(edmEntityAccount);

  return createOrUpdateCall(payload, {
    entityName: 'Model.NewCustomerAcquisitionGoal',
  });
};
